export class SMSTemplate {
    public WebCodePrefix: string;
    public SMSText : string;
}
